<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script> 
import { mapActions, mapGetters } from "vuex"
import 'element-ui/lib/theme-chalk/index.css'

export default {
  name: "App",
  created() {
  },
  // computed: mapGetters({ socket: "socket" }),
  methods: {
    // ...mapActions(["ConnectSocket"])
  }
};
</script>

<style lang="less">
html,body,p,ul,li{
  padding: 0;
  margin: 0;
}
body {
  font-size: 14px;
  font-family: PingFang SC;
  color: #333333;
}
.flashImg {
  vertical-align: bottom;
  max-height: 400px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.tc {
  text-align: center;
}
.tl {
  text-align: left;
}
.tr {
  text-align: right;
}
.mt5 {
  margin-top: 5px;
}
.mt10 {
  margin-top: 10px;
}
.mt15 {
  margin-top: 15px;
}
.mt20 {
  margin-top: 20px;
}
.mb5 {
  margin-bottom: 5px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.mb20 {
  margin-bottom: 20px;
}
.mr20 {
  margin-right: 20px;
}
.pb20 {
  padding-bottom: 20px;
}
.pt20 {
  padding-top: 20px;
}
.content {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}
.index {
  
}
.title1 {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.title2 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.title3 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.title4 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.minTitle1 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.minTitle2 {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.bg1 {
    background-color: #F5F7FA;
}
.bg2 {
    background-color: #ffffff;
}
.flash {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    .gg {
        position: absolute;
        color: #bbbbbd;
        top: 70px;
        .topNav {
          display: inline-block;
          padding: 1px 8px;
          border: 1px solid #bbbbbd;
          border-radius: 20px;
          font-size: 12px;
        } 
        .title {
          font-size: 32px;
          margin-top: 10px;
          color: #ffffff;
        }
        .minTitle {
          font-size: 14px;
          margin-top: 10px;
          color: #bbbbbd;
          line-height: 20px;
          width: 450px;
        }
        .button {
          margin-top: 15px;
          padding: 10px 15px;
          color: #FEFEFE;
          display: inline-block;
          background-color: #E60012;
          border-radius: 5px;
          font-size: 14px;
          cursor: pointer;
        }
        .minColor {
          color: #FEFEFE;
        }
        .minColor2 {
          color: #333333;
        }
        .button2 {
          background: none;
          border: 1px solid #666666;
        }
    }
    
}
</style>
<style lang="less">
  @media (max-width: 1230px) {
    .content {
      padding: 0 50px;
    }
    .title1 {
      margin-top: 30px;
      margin-bottom: 15px;
    }
    .minTitle1 {
      margin-bottom: 20px;
    }
  }
  @media (max-width: 768px) {
    .content {
      padding: 0 15px;
    }
    .title1 {
      font-size: 20px;
      margin-bottom: 10px;
    }
    .minTitle1 span {
      display: block;
    }
  }
</style>